<template><div><h1 id="dimensionen-definieren-positionen" tabindex="-1"><a class="header-anchor" href="#dimensionen-definieren-positionen"><span>Dimensionen definieren, Positionen</span></a></h1>
<p>Dimensionen definieren, Positionen — Dimensionspositionen für die Mailingauswertung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.eamaildim.html" title="Dimensionen zuordnen">Dimensionen zuordnen</RouteLink> vorgenommen.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Mailingauswertung → Mailingauswertung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Code</dt>
<dd>Anzeige des Codes zur Position.</dd>
<dt>Beschreibung</dt>
<dd>Bezeichnung der Position (editierbar).</dd>
<dt>Parameter</dt>
<dd>Anzeige der Parameter zur Position.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="dimensionen-berechnen" tabindex="-1"><a class="header-anchor" href="#dimensionen-berechnen"><span>Dimensionen berechnen</span></a></h3>
<p>Mit diesem Job werden die Dimenesionswerte pro Adresse definiert und in die Ereignisverknüpfungen geschrieben (für Benutzer nicht sichtbar).</p>
<h3 id="berechnung-zurucksetzen" tabindex="-1"><a class="header-anchor" href="#berechnung-zurucksetzen"><span>Berechnung zurücksetzen</span></a></h3>
<p>Mit diesem Job werden die Dimensionswerte aus den Ereignisverknüpfungen gelöscht (für Benutzer nicht sichtbar).</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tbldim.html" title="Dimension">Dimensionen</RouteLink></p>
</div></template>


